module.exports = __webpack_public_path__ + "static/img/cossub1.5ec384b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cossub1.jpg
// module id = bP95
// module chunks = 0